import { useRouter } from "next/router";

import { useTrackerAuth } from "components/AuthProvider";
import { UserWithCompany } from "lib/api/cm/utils/types";
import { EcsUserType } from "lib/shared/users/getEcsUserType";

export function useEcsUserType(cmUser?: UserWithCompany | null) {
  const { user: nonCmUser, pending } = useTrackerAuth();
  const router = useRouter();

  if (router.pathname.includes("ecs-shared")) {
    return EcsUserType.SHARE_LINK_RECIPIENT;
  }

  const user = cmUser ?? nonCmUser; // temp until we merge tracker auth with cm client

  if (pending || !user) {
    return EcsUserType.UNKNOWN;
  }

  // We've put the ecsUserType on the user object in the auth provider... access it here or return the unknown type if it's not set
  return user.ecsUserType ?? EcsUserType.UNKNOWN;
}
